import { render, staticRenderFns } from "./ImportProducts.vue?vue&type=template&id=5b9cfcc9&scoped=true"
import script from "./ImportProducts.vue?vue&type=script&lang=js"
export * from "./ImportProducts.vue?vue&type=script&lang=js"
import style0 from "./ImportProducts.vue?vue&type=style&index=0&id=5b9cfcc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9cfcc9",
  null
  
)

export default component.exports